import styled from 'styled-components'
import { COLORS } from '@themes'

type StyleProps = {
  $isDashboard: boolean
  $isDisplay: boolean
}

export const LayoutStyle = styled.div.attrs((props) => ({}))<StyleProps>`
  background: ${({ $isDashboard }) => ($isDashboard ? COLORS.BLUE_2 : '#151521')};
  width: 100%;
  height: 100%;
  font-family: Poppins, Helvetica, sans-serif;
  min-width: 390px;
  overflow: auto;

  .tab {
    display: flex;
    flex-direction: row;
    height: 93%;
  }

  .page {
    transition: all 0.3s ease-out;
    opacity: ${({ $isDisplay }) => ($isDisplay ? 1 : 0)};
  }
`
